import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { HowItWorksStep } from '@/types/home.types';

interface HowItWorksSectionProps {
  steps: HowItWorksStep[];
}

const HowItWorksSection: FC<HowItWorksSectionProps> = ({ steps }) => (
  <section id={SECTION_IDS.howItWorks} className="scroll-mt-20 bg-site-bg">
    <div className={SITE_CONTAINER}>
      <hr className="h-0.5 border-0 bg-site-line" />

      <div className="py-14 md:py-[72px]">
        <span className="mb-4 block font-site text-[13px] tracking-[0.08em] text-site-accent-deep uppercase">
          How it works
        </span>

        <ol className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,260px),1fr))] gap-10">
          {steps.map((step) => (
            <li key={step.step} className="border-t-2 border-site-ink pt-5">
              <span className="block font-site text-[56px] leading-none font-extrabold text-site-accent">
                {step.step}
              </span>
              <h3 className="mt-5 font-site text-[22px] font-extrabold">{step.title}</h3>
              <p className="mt-2 font-site text-base leading-[1.5] text-site-ink/80">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
